var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    {
      staticClass: "wrap-option",
      class: { selected: _vm.selectedCategory },
      attrs: { "vs-w": "12" }
    },
    [
      _c("vs-col", { attrs: { "vs-lg": "8", "vs-sm": "8", "vs-xs": "12" } }, [
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.option.valor,
                expression: "option.valor"
              }
            ],
            staticClass: "input-option",
            class: {
              "input-blocked": !_vm.editMood,
              "input-edit": _vm.editMood
            },
            attrs: { maxlength: "10", size: "small" },
            domProps: { value: _vm.option.valor },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.option, "valor", $event.target.value)
              }
            }
          })
        ]),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.option.descripcion,
                expression: "option.descripcion"
              }
            ],
            staticClass: "input-option",
            class: {
              "input-blocked": !_vm.editMood,
              "input-edit": _vm.editMood
            },
            attrs: { maxlength: "100", size: "small" },
            domProps: { value: _vm.option.descripcion },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.option, "descripcion", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c(
        "vs-col",
        {
          attrs: {
            "vs-type": "flex",
            "vs-justify": "flex-end",
            "vs-align": "center",
            "vs-lg": "4",
            "vs-sm": "4",
            "vs-xs": "12"
          }
        },
        [
          !_vm.editMood
            ? _c(
                "CheckPermission",
                { attrs: { permission: "ED029" } },
                [
                  _c("vs-button", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Editar Opción",
                        expression: "'Editar Opción'"
                      }
                    ],
                    staticClass: "mr-2",
                    attrs: {
                      color: "primary",
                      size: "small",
                      type: "border",
                      icon: "edit"
                    },
                    on: {
                      click: function($event) {
                        return _vm.editOption(_vm.option)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.editMood
            ? _c("vs-button", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: "Guardar edición",
                    expression: "'Guardar edición'"
                  }
                ],
                staticClass: "mr-2",
                attrs: {
                  color: "success",
                  size: "small",
                  type: "border",
                  icon: "save"
                },
                on: {
                  click: function($event) {
                    return _vm.saveOption(_vm.option)
                  }
                }
              })
            : _vm._e(),
          _vm.editMood
            ? _c("vs-button", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: "Cancelar edición",
                    expression: "'Cancelar edición'"
                  }
                ],
                staticClass: "mr-2",
                attrs: {
                  color: "danger",
                  size: "small",
                  type: "border",
                  icon: "cancel"
                },
                on: {
                  click: function($event) {
                    return _vm.cancelOption()
                  }
                }
              })
            : _vm._e(),
          _c(
            "CheckPermission",
            { attrs: { permission: "ED030" } },
            [
              _c("vs-switch", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.selected
                      ? "Deshabilitar opción"
                      : "Habilitar opción",
                    expression:
                      "selected ? 'Deshabilitar opción' : 'Habilitar opción'"
                  }
                ],
                attrs: { color: "primary" },
                on: {
                  click: function($event) {
                    return _vm.toggleEnableOptionRegion({
                      option: _vm.option,
                      selected: _vm.selected,
                      type: _vm.type
                    })
                  }
                },
                model: {
                  value: _vm.selected,
                  callback: function($$v) {
                    _vm.selected = $$v
                  },
                  expression: "selected"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }